import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { CountButton } from 'src/client/components/ui/CountButton';
import { useDispatch } from 'react-redux';
import { addFavor, removeFavor } from '../../redux/modules/favoriteInfo';
import { formatViews } from '../../utils/converters';
import { ModelSubscriptionModal } from '../../components/modals/ModelSubscriptionModal';
import { useSelector } from '../../redux/modules/helpers/useSelector';
import { redirectToJoin, useJoinUrlGenerator } from 'src/client/components/buttons/JoinButton';
import { FAVORITE_BUTTON } from 'src/client/constants/joinCampaigns';

const Div = styled.div`
  .btn.favorited {
    background-color: ${(props) => props.theme.primary7};
  }

  .count-btn {
    margin-top: 12px;
  }

  .count {
    border-color: ${(props) => props.theme.primary3};

    ::before {
      border-right-color: ${(props) => props.theme.primary3};
    }
    ::after {
      border-right-color: ${(props) => props.theme.primary1};
    }
  }
`;

const notifiableTypes = ['MODEL'];

type Props = {
  favoriteCount: number;
  objectUUID: string;
  objectType: 'GALLERY' | 'MOVIE' | 'MODEL' | 'PHOTOGRAPHER';
};

export const FavoriteButton = (props: Props) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const favoriteInfo = useSelector((state) => state.favoriteInfo.favoritingObjectUUIDs);
  const generateJoinUrl = useJoinUrlGenerator();

  const [showFollowModal, setFollowModalVisibility] = useState(false);

  const isFavorited = favoriteInfo.includes(props.objectUUID);
  const onToggle = user
    ? (notifyUser = false) => {
        const favorParams = {
          objectUUID: props.objectUUID,
          objectType: props.objectType?.toUpperCase(),
          notify: notifyUser,
        };

        if (isFavorited) {
          dispatch(removeFavor(favorParams));
        } else {
          dispatch(addFavor(favorParams));
        }
      }
    : () => redirectToJoin(generateJoinUrl, FAVORITE_BUTTON);

  const favoriteText = ['GALLERY', 'MOVIE'].includes(props.objectType) ? 'Favorite' : 'Follow';
  const unfavoriteText = ['GALLERY', 'MOVIE'].includes(props.objectType) ? 'Unfavorite' : 'Unfollow';

  return (
    <Div>
      {props.objectType === 'MODEL' && (
        <ModelSubscriptionModal
          showModal={showFollowModal}
          onToggleFavor={onToggle}
          hideModal={() => setFollowModalVisibility(false)}
        />
      )}
      <CountButton
        count={formatViews(props.favoriteCount + (isFavorited ? 1 : 0))}
        btnClassName={`btn-primary ${isFavorited ? 'favorited' : ''}`}
        onClick={() =>
          user && !isFavorited && notifiableTypes.includes(props.objectType)
            ? setFollowModalVisibility(true)
            : onToggle()
        }
      >
        {isFavorited ? unfavoriteText : favoriteText}
      </CountButton>
    </Div>
  );
};
